
import axios from 'axios'

export async function removeWish ({ ...values }) {
  let data = {
    action: 'delete',
    id_wishlist: '',
    id_product: values.idProduct,
    id_product_attribute: values.idProductAttribute,
    quantity: values.quantity,
    priority: '',
    refresh: '',
    token: static_token, // eslint-disable-line
  }

  const response = await axios.get(baseDir + 'modules/blockwishlist/managewishlist.php', { // eslint-disable-line
    params: data
  })

  return response.data
}



// WEBPACK FOOTER //
// ./src/api/wishList/removeWish.js